import {GroupedSizeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownSizeGrouped} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useGroupedSizeFilterSection} from '../../shared/useGroupedSizeFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: GroupedSizeFilterSection;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  resetFilter: (slug: string) => void;
  resetFilters: (slug: string[]) => void;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionSizeGrouped: FC<Props> = ({
  activeFilters,
  data,
  resetFilter,
  resetFilters,
  setFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {
    normalizedContent,
    handleSetSizeFilter,
    handleTabClick,
    handleResetFilter,
  } = useGroupedSizeFilterSection({
    data,
    setFilter,
    resetFilters,
  });

  return (
    <FilterDropdownSizeGrouped
      activeFilters={activeFilters}
      content={normalizedContent}
      onTabsReset={resetFilter}
      onFilterReset={handleResetFilter}
      onSizeClick={handleSetSizeFilter}
      onTabClick={handleTabClick}
      onOpen={() => onOpen('sizes', filterLabel)}
      onClose={() => onClose('sizes', filterLabel)}
    />
  );
};
